var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7 2.61667H12.3167C12.7454 2.61667 13.1566 2.787 13.4598 3.09018C13.763 3.39336 13.9333 3.80457 13.9333 4.23334V15.55C13.9333 15.9788 13.763 16.39 13.4598 16.6932C13.1566 16.9963 12.7454 17.1667 12.3167 17.1667H2.61667C2.1879 17.1667 1.77669 16.9963 1.47351 16.6932C1.17033 16.39 1 15.9788 1 15.55V4.23334C1 3.80457 1.17033 3.39336 1.47351 3.09018C1.77669 2.787 2.1879 2.61667 2.61667 2.61667H4.23333",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89173 1H5.04173C4.5953 1 4.2334 1.3619 4.2334 1.80833V3.425C4.2334 3.87143 4.5953 4.23333 5.04173 4.23333H9.89173C10.3382 4.23333 10.7001 3.87143 10.7001 3.425V1.80833C10.7001 1.3619 10.3382 1 9.89173 1Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.3196667aca815794defce49f348c27d2.svg";
export { ForwardRef as ReactComponent };